import { VIEWPORT_CULLING_THRESHOLD } from './viewportCulling';

export const SEMANTIC_ZOOM_MAX_SCALE = 0.45;
export const SEMANTIC_ZOOM_LABEL_LENGTH = 48;

export function shouldUseSemanticZoom({
  scale,
  branchVisibleNodeCount,
  threshold = VIEWPORT_CULLING_THRESHOLD,
} = {}) {
  return Number.isFinite(scale)
    && scale <= SEMANTIC_ZOOM_MAX_SCALE
    && Number.isFinite(branchVisibleNodeCount)
    && branchVisibleNodeCount > threshold;
}

export function getSemanticZoomLabel(value, maxLength = SEMANTIC_ZOOM_LABEL_LENGTH) {
  const firstLine = String(value || '')
    .split('\n')
    .map((line) => line.trim())
    .find(Boolean) || 'Untitled idea';
  const plain = firstLine
    .replace(/^#{1,6}\s+/, '')
    .replace(/^[-*+]\s+/, '')
    .replace(/^\d+\.\s+/, '')
    .replace(/^>\s?/, '')
    .replace(/\[([^\]]+)\]\([^)]+\)/g, '$1')
    .replace(/[*_`~]/g, '')
    .trim() || 'Untitled idea';
  const safeLength = Math.max(1, Number.isFinite(maxLength) ? maxLength : SEMANTIC_ZOOM_LABEL_LENGTH);
  return plain.length > safeLength
    ? `${plain.slice(0, safeLength - 1).trimEnd()}…`
    : plain;
}
